import { genStyles } from "tripkit-react";
import { TKUITheme, black, white } from "tripkit-react/dist/jss/TKUITheme";

const multiSignInFormJss = (theme: TKUITheme) => ({
    main: {
        padding: '20px',
        ...genStyles.flex,
        ...genStyles.column,
        '& > *': {
            marginBottom: '20px'
        }
    },
    description: {
        fontSize: '1.125rem',
        lineHeight: '1.5rem',
        padding: '20px',
        textAlign: 'center'
    },
    or: {
        display: 'flex',
        alignItems: 'center',
        '& div': {
            borderTop: '1px solid ' + black(),
            ...genStyles.grow
        },
        '& div:first-child': {
            marginRight: '10px'
        },
        '& div:last-child': {
            marginLeft: '10px'
        }
    },
    divider: {
        ...theme.divider
    },
    termsAndPrivacy: {
        textAlign: 'center',
        ...theme.textColorGray,
        margin: '10px 15px',
        '& a': {
            color: theme.colorPrimary
        }
    },
    logo: {
        height: '90px',
        ...theme.isDark ? {
            '& path': {
                fill: white(1)
            }
        } : {}
    }
});

export default multiSignInFormJss;